




import Class from './c-chart-multiple-axes-view';
export default Class;
